import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useChatStatusRealtime = () => {
  const queryClient = useQueryClient();
  
  useEffect(() => {
    const chatChannel = supabase
      .channel('chat-status-realtime')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notification_chat'
        },
        () => {
          queryClient.invalidateQueries({ 
            queryKey: ['all-notification-chat-counts'] 
          });
        }
      )
      .subscribe();

    const readStatusChannel = supabase
      .channel('chat-read-status-realtime')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notification_chat_read_status'
        },
        () => {
          queryClient.invalidateQueries({ 
            queryKey: ['all-notification-chat-counts'] 
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(chatChannel);
      supabase.removeChannel(readStatusChannel);
    };
  }, [queryClient]);
};
